<template>
    <div class="card border-light rounded-3 shadow-lg">
        <div class="card-body">
            <h2 class="card-title h4 mb-4 text-primary">Vos questionnaires en cours</h2>
            <div v-if="loading">Chargement...</div>
            <ul v-else-if="availableQuestionnaires && availableQuestionnaires.length"
                class="list-group list-group-flush">
                <li class="list-group-item d-none d-md-block">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <b>Nom de l'étude</b>
                        </div>
                        <div class="col-12 col-md-6">
                            <b>Dates d'ouverture</b>
                        </div>
                    </div>
                </li>
                <li v-for="q in availableQuestionnaires" :key="q.id" class="list-group-item py-1">
                    <div class="row">
                        <div class="col-12 col-md-6 d-flex align-items-center">{{ q.title }}</div>
                        <div
                            class="col-12 col-md-6 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                            <small class="mt-2 mt-md-0">{{ formatDate(q.startDate) }} - <span
                                    :class="warnDate(q.endDate) ? 'text-danger' : ''">{{ formatDate(q.endDate)
                                    }}</span></small>
                            <span v-if="isLocked(q)" class="d-inline-block mt-2 mt-md-0" tabindex="0"
                                :title="`Vous devez d'abord répondre au(x) questionnaire(s) : ${pendingRequiredTitles(q)}`">
                                <a class="btn btn-secondary btn-sm rounded-pill disabled" aria-disabled="true">Je participe</a>
                            </span>
                            <a v-else :href="`${cawiBaseUrl}/${q.id}/${q.id}.pl?login=${q.cw_track}`"
                                class="btn btn-primary btn-sm rounded-pill mt-2 mt-md-0">Je participe</a>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else-if="availableQuestionnaires !== false">Aucun questionnaire disponible actuellement.</div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Tools from '../tools'

export default {
    name: 'AvailableQuestionnaires',
    mixins: [Tools],
    data: () => ({
        cawiBaseUrl: process.env.VUE_APP_CAWI_BASE_URL,
    }),
    computed: {
        ...mapState(['loading', 'questionnaires']),
        availableQuestionnaires() {
            if (this.questionnaires !== null) {
                return this.questionnaires.filter((q) => !q.isAnalysis && !q.complete && !q.refused && !q.closed && !this.isHidden(q))
            }
            return false
        },
    },
    methods: {
        findQuestionnaire(id) {
            return (this.questionnaires || []).find((q) => q.id === id)
        },
        requiredIds(q) {
            if (!q.require) return []
            return q.require.split(';').map((id) => id.trim()).filter(Boolean)
        },
        pendingRequiredIds(q) {
            return this.requiredIds(q).filter((id) => {
                const required = this.findQuestionnaire(id)
                return !required || !required.complete
            })
        },
        isHidden(q) {
            return this.requiredIds(q).some((id) => {
                const required = this.findQuestionnaire(id)
                return !!required && required.refused
            })
        },
        isLocked(q) {
            return this.pendingRequiredIds(q).length > 0
        },
        pendingRequiredTitles(q) {
            return this.pendingRequiredIds(q)
                .map((id) => {
                    const required = this.findQuestionnaire(id)
                    return `« ${required ? required.title : id} »`
                })
                .join(', ')
        },
    },
}
</script>
